<template>
  <div ref="checkoutWidget" class="ventrata-booking-checkout-widget-container">
    <div class="summary-container">
      <div class="summary-header">
        <div class="summary-header-img">
          <img
            :src="require('@/assets/svg/added-to-cart.svg')"
            alt="added-to-cart"
            class="summary-header-icon"
          >
        </div>
        <div class="summary-header-text">
          Added to cart
        </div>
      </div>
      <div class="countdown-container">
        <span>
          We’ll hold your spot for
        </span>
        <CustomCountDown
          v-if="expiredCountdown !== null"
          :initial-time="expiredCountdown"
          style="margin: 0 8px;"
        />
        <span>
          minutes.
        </span>
      </div>
      <div class="buttons-container">
        <CustomButton
          text="Continue shopping"
          variant="secondary"
          icon="shopping-cart"
          :disabled="expiredCountdown <= 0"
          @click="onContinueShopping"
        >
          <template #icon>
            <img
              :src="require('@/assets/icon/shopping-cart.svg')"
              alt="shopping-cart"
            >
          </template>
        </CustomButton>
        <CustomButton
          text="Checkout now"
          variant="primary"
          icon="lock"
          :disabled="expiredCountdown <= 0"
          @click="onCheckout"
        >
          <template #icon>
            <img
              :src="require('@/assets/icon/shopping-lock.svg')"
              alt="shopping-cart"
            >
          </template>
        </CustomButton>
      </div>
    </div>
    <div v-if="currentTours.length > 0" class="tours-container">
      <BookingSimilarTours
        :tours="currentTours"
        :title="'Frequently booked together:'"
        :show-checkout="false"
        :on-checkout="onCheckout"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomButton from '@/components/utils/basic/CustomButton.vue'
import CustomCountDown from '@/components/utils/basic/CustomCountDown.vue'
import BookingSimilarTours from '@/components/containers/tour/BookingSimilarTours.vue'

export default {
  name: 'VentrataBookingCheckoutWidget',
  components: {
    CustomButton,
    CustomCountDown,
    BookingSimilarTours
  },
  props: {
    tours: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  data () {
    return {
      expiredCountdown: null
    }
  },
  computed: {
    ...mapGetters({ cart: 'ventrata/cart' }),
    currentTours () {
      return this.tours
    },
    orderID () {
      return this.cart?.id
    }
  },
  async mounted () {
    this.$refs.checkoutWidget.scrollIntoView({ behavior: 'smooth', block: 'start' })
    const expiredAt = this.cart?.utcExpiresAt
    if (expiredAt) {
      const diff = new Date(expiredAt) - Date.now()
      this.expiredCountdown = Math.floor(diff / 1000)
    }
  },
  methods: {
    onContinueShopping () {
      location.href = '/' + this.$route.params.city + '/'
    },
    onCheckout () {
      location.href = '/payment/'
    }
  }
}
</script>

<style lang="scss" scoped>
.ventrata-booking-checkout-widget-container {
  .countdown-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 8px;
    @include font__subtitle-1--regular();
    color: $woi-blackberry;
  }

  .buttons-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;

    .button-text {
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0px;
    }
  }

  .summary-container {
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 24px;
    background-color: $text-white;

    button {
      text-transform: uppercase;
    }
  }

  .summary-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .summary-header-icon {
    width: 64px;
    height: 64px;
  }

  .summary-header-text {
    @include font__title-1--regular();
    color: $blackberry;
  }
}

@media screen and (max-width: 1024px) {
  .ventrata-booking-checkout-widget-container {
    display: flex;
    align-items: center;
    flex-direction: column;

    .countdown-container {
      @include font__paragraph-1--medium();
    }

    .summary-header-text {

    }
  }

  .summary-container {
    width: 100%;
    max-width: 410px;
  }

  .tours-container {
    width: 100%;
    max-width: 410px;
  }
}
</style>
